module.exports = __webpack_public_path__ + "static/media/default_fallback_1.b3017a02.png";